export function tmPelaFidelidade(dataFidelidade: string | null | undefined, hoje = new Date()): number | null {
  const m = String(dataFidelidade || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const inicioAno = Number(m[1]) - 2;
  const mes = Number(m[2]);
  const dia = Number(m[3]);
  let meses = (hoje.getFullYear() - inicioAno) * 12 + (hoje.getMonth() + 1 - mes);
  if (hoje.getDate() < dia) meses -= 1;
  return meses;
}

export function rotuloFidelidadeConta(dataFidelidade: string | null | undefined, texto?: string | null): string {
  const m = String(dataFidelidade || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `Fidelidade conta ${m[3]}/${m[2]}/${m[1]} · TM ${tmPelaFidelidade(dataFidelidade)}`;
  if (/sem fideliza/i.test(texto || '')) return 'Sem fidelização na conta';
  return '—';
}
